import Skeleton from 'react-loading-skeleton';
import { useBranding } from '~/lib/branding';

export function SkeletonCard({ height }: { height: number }) {
  return (
    <Skeleton
      height={height}
      borderRadius={10}
      baseColor="var(--color-skeleton-base)"
      highlightColor="var(--color-skeleton-highlight)"
    />
  );
}

export function SkeletonCircle({ size }: { size: number }) {
  const branding = useBranding();
  return (
    <Skeleton
      height={size}
      width={size}
      baseColor={branding === 'hero' ? '#00579b' : '#8876FF'}
      highlightColor={branding === 'hero' ? '#1ca0db' : '#7950AC'}
      circle
      className="flex items-center justify-center"
    />
  );
}
